import React from 'react';
import Scroll from 'react-custom-scroll';
import PalettePicker from './palettePicker';
import TextLabel from '../textLabel';
export default (function (props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('color-picker-palette-picker-dialog')
  }, /*#__PURE__*/React.createElement(TextLabel, {
    value: props.textKeys.colorPalettes || 'Color Palettes',
    shouldTranslate: props.shouldTranslate,
    className: "palette-picker-dialog-header"
  }), /*#__PURE__*/React.createElement(Scroll, null, /*#__PURE__*/React.createElement("div", {
    className: "palette-picker-dialog-palettes"
  }, /*#__PURE__*/React.createElement(PalettePicker, {
    value: props.value,
    onChange: props.onChange,
    palettePresets: props.palettePresets
  }))));
});